<template lang="pug">
    MglMarker(
        ref="pin"
        :coordinates="marker.coordinates"
        @mouseenter="showTooltip"
        @mouseleave="hideTooltip"
    )
        //- .marker(slot="marker")
            h5.char(v-if="marker.char") {{ marker.char }}
            font-awesome-icon(icon="map-marker")
        .round-marker-container(slot="marker")
            component(:is="tag" v-bind="props" :class="{ visible: marker.visible }")
                font-awesome-icon(icon="map-marker")
        MglPopup(
            v-if="marker.description"
            :offset="20"
            :close-button="false"
        )
            .marker-popover(
                @mouseover="showTooltip"
                @mouseout="hideTooltip"
            )
                .description(v-if="marker.description" v-html="marker.description")
</template>

<script>
import { get } from '@/helpers'
import {  MglMarker, MglPopup } from 'vue-mapbox'

export default {
    name: 'Pin',
    data: () => ({
        timeout: undefined,
        delay: 100,
    }),
    props: {
        marker: {
            type: Object,
            required: true
        }
    },
    components: {
        MglMarker,
        MglPopup,
    },
    computed: {
        tag() {
            let tag = 'div';
            if (this.path) tag = 'router-link';
            else if (this.href) tag = 'a';
            return tag;
        },
        props() {
            let props = {};

            switch (this.tag) {
                case 'router-link':
                    props.to = this.path;
                    break;
            }

            return props;
        },
        hyperlink() {
            return get(this.marker, 'hyperlink') || {};
        },
        href() {
            let href = false;

            if (this.hyperlink.type !== 'internal' && get(this.hyperlink, 'href')) {
                const link = this.hyperlink.href;
                switch (this.hyperlink.type) {
                    case 'external':
                        if (!link.startsWith('https://') && !link.startsWith('http://')) href = `https://${link}`;
                        else href = link;
                        break;

                    case 'mailto':
                        href = `mailto:${link}`;
                        break;

                    case 'tel':
                        href = `tel:${link}`;
                        break;
                }
            }

            return href;
        },
        target() {
            return get(this.hyperlink, 'target') || '_self';
        },
        path() {
            if (this.hyperlink.type === 'internal' && get(this.hyperlink, 'menuItem.path'))
                return this.hyperlink.menuItem.path;
            else return false;
        },
        linkText() {
            return get(this.hyperlink, 'name') || 'mehr...';
        },
    },
    methods: {
        showTooltip() {
            if (this.timeout) clearTimeout(this.timeout)
            if (this.$refs.pin && this.$refs.pin.marker.getPopup() && ! this.$refs.pin.marker.getPopup().isOpen()) {
                this.$refs.pin.marker.togglePopup()
            }
        },
        hideTooltip() {
            this.timeout = setTimeout(() => {
                if (this.$refs.pin && this.$refs.pin.marker.getPopup() && this.$refs.pin.marker.getPopup().isOpen()) {
                    this.$refs.pin.marker.togglePopup()
                }
            }, this.delay);
        },
    }
}
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

.marker .char
    margin: 0
    padding: 0
    position: absolute
    text-transform: uppercase
    font-size: 1rem
    width: 24px
    text-align: center
    height: 26px
    line-height: 26px
    color: white
    font-weight: bold

.mapboxgl-marker
    &:after
        box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.8)
        content: '';
        position: absolute
        width: 10px
        height: 0px
        bottom: -2px
        left: calc(50% - 5px)
    .round-marker
        background-color: $primary
        color: $white
        font-size: 1rem
        padding: .45rem
        border-radius: 999px
        line-height: 1rem
        height: auto
        opacity: 0
        transform: scale(.65)
        transition: opacity .3s cubic-bezier(1.0, 0.5, 0.8, 1.0), transform .3s ease
        &.visible
            opacity: 1
            transform: scale(1)
        svg
            font-size: inherit

.mapboxgl-marker
    font-size: 2rem
    line-height: 2rem
    height: 2rem
    // &:after
    //     content: ''
    //     position: absolute
    //     width: 10px
    //     height: 0px
    //     bottom: -2px
    //     left: calc(50% - 5px)
    //     box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.8)

.marker-popover
    .description
        font-size: .85rem
        line-height: 1.3
        ::v-deep
            a
                outline: none
                text-decoration: underline
                &:hover
                    color: lighten($primary, 20%)
            p
                margin-top: 0
                margin-bottom: 4px
                &:last-child
                    margin-bottom: 0

.fa-map-marker
    color: $primary
</style>
